<template>
    <el-cascader
        size="small"
        v-model="value"
        :options="list"
        @change="activeChange"
        :props="props"
    >
    </el-cascader>
</template>

<script>
import OrderService from "~/services/order";
import Config from "~/config/params";

export default {
    name: "OrderType",
    data() {
        return {
            list: [],
            props: {
                // expandTrigger: 'hover',
                checkStrictly: true
            },
            value: [],
        };
    },

    props: {
        params: {
            type: Object,
            required: false,
            value: function () {
                return {};
            }
        },
    },

    //vue.js 钩子函数，在实例创建完成后立即调用
    created() {
        this.list = OrderService.getOrderType(this.params.tab);
        if(this.params.type > 5){
            this.value = [Config.TYPE_RENEW, this.params.type];
        }else{
            this.value = [this.params.type];
        }
        // console.log('进入created：', this.list, this.params, this.value);
    },

    methods: {

        activeChange(value){
            // console.log('activeChange:', value);
            this.value = value;
            this.$emit("change", this.value);
        },

        //地区选择value重置
        reset() {
            this.value = [];
        },
    }
}

</script>


// WEBPACK FOOTER //
// src/widgets/OrderType.vue